export const getTablePreferences = (tableKey, configs = []) => configs.find(({ key }) => tableKey === key);
